// Loads the active restaurant's plan once the bunker can sign (the snapshot
// is owner-gated, so it needs a merchant session). Mounted from AdminLayout;
// re-runs when the active restaurant changes.

import { useEffect } from 'react'
import { useLoyaltyContext } from '@/hooks/useLoyaltyContext'
import { useBilling } from '@/state/useBilling'

export function useBillingLoader(): void {
  const ctx = useLoyaltyContext()
  const refresh = useBilling((s) => s.refresh)
  const loadedFor = useBilling((s) => s.restaurantPubkey)
  const loaded = useBilling((s) => s.loaded)

  useEffect(() => {
    if (!ctx) return
    if (loaded && loadedFor === ctx.restaurantPubkey) return
    void refresh(ctx)
  }, [ctx, refresh, loaded, loadedFor])
}
